<template>
    <div
        class="flex items-center overflow-hidden fixed inset-0 z-50"
        :class="position"
    >
        <transition
            enter-active-class="transition duration-150 ease-in"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                class="absolute inset-0 bg-gradient-to-tr from-gray-700 via-gray-900 to-gray-700 opacity-90"
                @click="overlayClick"
            />
        </transition>
        <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="animate-fadeOut"
        >
            <slot />
        </transition>
    </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue'

export default {
    name: 'Overlay',
    props: {
        position: {
            type: String,
            default: 'justify-center'
        },
        enableScroll: Boolean
    },
    emits: ['overlay-click'],
    setup (props, { emit }) {
        const overlayClick = event => {
            emit('overlay-click', event)
        }

        if (!props.enableScroll) {
            onMounted(() => {
                document.documentElement.classList.add('modal-open')
            })

            onUnmounted(() => {
                document.documentElement.classList.remove('modal-open')
            })
        }

        return {
            overlayClick
        }
    }
}
</script>
